import {
  resetCurrentEmploymentFirstDebtor,
  resetCurrentEmploymentSecondDebtor
} from './resetCurrentEmploymentUntilErrors'

const reactions = [
  resetCurrentEmploymentFirstDebtor,
  resetCurrentEmploymentSecondDebtor
]

export default reactions
